import React, { useContext, useEffect, useState } from "react";
import {
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { updateDashboardForm } from "../../ducks/redux/actions/dashboardReducer.actions";
import {
  userChosenVulnerabilityQuestion,
  userChosenVulnerabilityAdditionalInformation,
  userChosenCovidQuestion,
  userChosenContactDetails,
  userChosenContactPhone,
  userChosenContactName,
  userChosenRelationDetails,
  isEditState,
  resumeDraftRepair,
  setNavHeaderText,
  showFooter
} from "../../ducks/redux/actions/userChoices";
import { RouteComponentProps, useHistory } from "react-router-dom";
import Loader from "react-loader-spinner";
import Button from "../../storybook/Button";
import "../../compositions/VulnerabilityQuestion/index.scss";
import BackModal from "../Modal/BackModal";
import ExitModalAndSave from "../Modal/ExitModalAndSave";
import { WorksOrderRequest } from "../../models/WorksOrders/WorksOrderRequest";
import { workOrderRepairObject } from "../../ducks/redux/actions/getAddress";
import * as api from "../../api";
import { isUndefinedNullOrEmpty } from "../../utils/translation/helper";
import { FeatureFlags } from "../contexts/FeatureFlags";

import HeaderJourney from "../../storybook/Header/HeaderJourney";
import Message from "../../storybook/Message";
import { getDMCSorCodeReference } from "../../utils/formatting";
import { isContinueButtonDisabled } from "../../ducks/redux/actions/FinancialReferral";

interface VulnerabilityQsProps extends RouteComponentProps<any> { }

const VulnerabilityQs: React.FC<VulnerabilityQsProps> = (props) => {
  const { t } = useTranslation();
  const { featureMedia }: any = useContext(FeatureFlags);
  const format = /^[\s|A-Za-z0-9 .,_@+#-%'’\-)+--^`~=¬£€()\\\/[\]?:;""{}]*$/;
  const dispatch = useDispatch();
  const history = useHistory();
  const userChosenVulnerabilityQuestionBackButton = useSelector(
    (state: any) => state.userChoicesReducer.userChosenVulnerabilityQuestion
  );
  const [isError, setError] = React.useState("none");
  const [textvalue, setTextValue] = useState("");
  const [radiovalue, setRadioValue] = useState(userChosenVulnerabilityQuestionBackButton ?? "No");
  const [isLoading, setIsLoading] = useState(false);
  const [buttondisable, setButtonDisable] = useState(false);
  const [closeAfterSaving, setCloseAfterSaving] = useState(false);
  const [blockRepairJourney, setBlockRepairJourney] = useState<any>();
  const [blockLoading, setEnhanceRepairEligibilityLoading] = useState(false);
  let [blockErrorCode, setBlockErrorCode] = useState("");
  const [V14AlertFlag, setV14AlertFlag] = useState("false");

  const dmcInspectionSorCodes = useSelector(
    (state: any) => state?.userChoicesReducer?.dmcInspectionSorCodeValues
  );

  const dmcRepairSorCodeValues = useSelector(
    (state: any) => state?.userChoicesReducer?.dmcRepairSorCodeValues
  );

  const priority = useSelector(
    (state: any) =>
      state?.dashboardReducer?.formState?.selectedRepairReasonObject[0]
        ?.priority
  );
  const EditState = useSelector(
    (state: any) => state.userChoicesReducer?.isEditState
  );

  const userChosenVulnerabilityAdditionalInformationBackButton = useSelector(
    (state: any) =>
      state.userChoicesReducer.userChosenVulnerabilityAdditionalInformation
  );
  const loggedInStatus = useSelector(
    (state: any) => state?.userChoicesReducer?.loginStatus
  );
  const eligibilityResponseObject = useSelector(
    (state: any) =>
      state?.dashboardReducer?.formState?.eligibilityResponseObject

  );
  const vandalismConfigValue = useSelector(
    (state: any) => state?.addresses?.vandalismtoggleValue
  );
  const resumeDraftRepairVal = useSelector((state: any) => state.userChoicesReducer.resumeDraftRepair);
  const userResumeDraftDataCache = useSelector((state: any) => state.userChoicesReducer.userResumeDraftDataCache);
  const userchosenDMC = useSelector((state: any) => state.userChoicesReducer?.DMCChecksavedAnswer);
  const priorityCode = useSelector((state: any) => state.userChoicesReducer?.repairPriority);
  const configSOR = useSelector((state: any) => state?.financialReferralReducer?.sordamp);
  const userChosenSOR = useSelector((state: any) => state?.userChoicesReducer?.userChosenSOR);
  const checkEnhancedEligibility = useSelector(
    (state: any) =>
      state.userChoicesReducer.checkEnhancedRepairEligibilityMyPeabody
  );

  const userChosenEmergencyQuestion = useSelector(
    (state: any) => state?.userChoicesReducer?.userChosenEmergencyQuestion
  );

  const customerIdentifier = useSelector(
    (state: any) => state.addresses?.customerid
  );

  const workOrderfromState = useSelector(
    (state: any) => state.addresses.workOrderRepair
  );
  const userChosenSORValue = useSelector(
    (state: any) => state.userChoicesReducer.userChosenSOR
  );
  const userChosenDuplicateQuestion = useSelector(
    (state: any) => state?.userChoicesReducer?.userChosenDuplicateQuestion
  );
  const assetId = useSelector(
    (state: any) => state?.addresses?.assetId
  );

  const priorityCodeValue = useSelector(
    (state: any) => state.userChoicesReducer?.repairPriority
  );

  const selectedSorCodeValue = useSelector((state: any) => state?.userChoicesReducer?.userChosenSOR);
  const selectedproperty = useSelector(
    (state: any) => state?.userChoicesReducer?.userChosenPropertyType
  );
  const isDMCEnabledtoggleValue = useSelector(
    (state: any) => state?.addresses?.isDMCEnabledtoggleValue
  );

  useEffect(() => {
    if (isUndefinedNullOrEmpty(loggedInStatus)) {
      props.history.push("/startpage");
      return;
    }
    setRadioValue(userChosenVulnerabilityQuestionBackButton);
    setTextValue(userChosenVulnerabilityAdditionalInformationBackButton);
    if (userChosenEmergencyQuestion === "Yes, I can provide access" || workOrderfromState?.isEmergency) {
      props.history.replace("/covidquestion");
    }

    // Checking default yes selection and displaying OOH message
    if (checkEnhancedEligibility && radiovalue === "Yes") {
      dispatch(isContinueButtonDisabled(true));
      setBlockErrorCode("E36")
      // Create a mock event to call updateSelection with the current radiovalue
      updateSelection({
        target: { value: radiovalue } as HTMLInputElement,
        preventDefault: () => { },
      } as React.ChangeEvent<HTMLInputElement>)
    } else {
      dispatch(isContinueButtonDisabled(false));
    }

  }, []);

  useEffect(() => {
    if ((radiovalue === "Yes" && textvalue !== "") || radiovalue === "No") {
      setError("none");
    }
    dispatch(userChosenVulnerabilityQuestion(radiovalue));

  }, [textvalue, radiovalue]);

  useEffect(() => {
    getV14AlertFlagValue();
    return () => {
      dispatch(setNavHeaderText("Contact Details"));
    };
  }, []);

  const getV14AlertFlagValue = async () => {
    try {
      const res = await api.GetAppConfigToggleValue("MyPeabodyV14VulnerableAlert");
      setV14AlertFlag(res.value);
    } catch (e) {
      console.error(e);
    }
  };

  const updateSelection = async (e: React.ChangeEvent<HTMLInputElement>) => {
    setButtonDisable(true);
    if (EditState === true) {
      dispatch(userChosenCovidQuestion(""));
      dispatch(userChosenContactDetails(""));
      dispatch(userChosenContactPhone(""));
      dispatch(userChosenContactName(""));
      dispatch(userChosenRelationDetails(""));
      dispatch(isEditState(false));
    }
    setRadioValue(e.target.value);
    dispatch(
      updateDashboardForm({
        selected: e.target.value,
        textArea: textvalue,
        assetId: assetId
      })
    );
    dispatch(userChosenVulnerabilityQuestion(e.target.value));
    if (e.target.value === "No") {
      setTextValue("");
      dispatch(userChosenVulnerabilityAdditionalInformation(""));
    }
    const advancedPayload = {
      "priority": workOrderfromState?.priority,
      "sor": userChosenSORValue,
      "isPotentialDuplicate": userChosenDuplicateQuestion.split("&")[2] ? true : (userChosenDuplicateQuestion === t("duplicateNoneofTheAbove")) ? true : false,
      "isVulnerable": e.target.value === "Yes",
      "channel": "CustomerSelfService"
    }

    if (checkEnhancedEligibility) {
      try {
        setEnhanceRepairEligibilityLoading(true);
        let enhanceEligibilityResp = await api.postEnhancedRepairEligibility(
          advancedPayload
        );
        setBlockRepairJourney(!enhanceEligibilityResp?.isEligible);
        setButtonDisable(!enhanceEligibilityResp?.isEligible);
        setBlockErrorCode(enhanceEligibilityResp?.errorCode);
        setEnhanceRepairEligibilityLoading(false);
        if (enhanceEligibilityResp?.errorCode === "E36") {
          dispatch(isContinueButtonDisabled(true));
        } else {
          dispatch(isContinueButtonDisabled(false));
        }
      }
      catch (e) {
        console.error(e);
        dispatch(showFooter(true));
        props.history.push({
          pathname: '/repairJourneyErrorPage',
          state: { message: 'repair_Journey_Error_Message1' }
        });
      }
    } else {
      setButtonDisable(false);
    }
  };

  const onChange = (e: any) => {
    if (EditState === true) {
      dispatch(userChosenCovidQuestion(""));
      dispatch(userChosenContactDetails(""));
      dispatch(userChosenContactPhone(""));
      dispatch(userChosenContactName(""));
      dispatch(userChosenRelationDetails(""));
      dispatch(isEditState(false));
    }
    if (!format.test(e.target.value)) {
      e.preventDefault();
      return;
    }
    setTextValue(e.target.value);
    dispatch(userChosenVulnerabilityAdditionalInformation(e.target.value));
    dispatch(
      updateDashboardForm({
        textArea: e.target.value,
        selected: radiovalue,
        assetId: assetId
      })
    );
  };

  const backButtonHandler = () => {
    dispatch(userChosenVulnerabilityAdditionalInformation(""));

    if (eligibilityResponseObject?.statuses.isInDefects === true && selectedproperty !== "Property" && vandalismConfigValue === true) {
      props.history.push("/vandalismquestion");
    }
    else {
      if (featureMedia === "true") {
        props.history.push("/uploadmedia");
      } else if (selectedproperty === "Property" && (dmcRepairSorCodeValues.includes(selectedSorCodeValue) || dmcInspectionSorCodes.includes(selectedSorCodeValue) || userchosenDMC === "Yes") && isDMCEnabledtoggleValue) {
        props.history.push("/DampAndMouldAssesment/3");
      } else if (selectedproperty === "Property" && isDMCEnabledtoggleValue) {
        props.history.push("/ConfirmedDampMould");
      }
    }
    dispatch(isContinueButtonDisabled(false))
  };

  const exitButtonHandler = () => {
    props.history.push("/customer360View");
  };

  const saveDraftAndExit = () => {
    setError("none");
    submitForm();
    setCloseAfterSaving(true);
    props.history.replace("/customer360View");
  };

  // update work order
  enum RepairCauseId {
    "General Wear and Tear" = 1,
    "Vandalism or Damage" = 4,
  }
  const userChosenVandalismQuestion = useSelector(
    (state: any) => state.userChoicesReducer.userChosenVandalismQuestion
  );
  const userChosenVandalismAdditionalInformation = useSelector(
    (state: any) =>
      state.userChoicesReducer.userChosenVandalismAdditionalInformation
  );
  const workOrderObject = useSelector(
    (state: any) => state.addresses.workOrderRepair
  );
  const submitForm = async () => {
    try {
      setIsLoading(true);
      setButtonDisable(true);

      workOrderObject.priority = priorityCodeValue;
      const _worksOrderRequest = new WorksOrderRequest(workOrderObject);
      const woRequestParameters =
        _worksOrderRequest.updateWorkOrderParameter(workOrderObject);
      if (radiovalue === t("Yes")) {
        woRequestParameters.isVulnerable = true;
        woRequestParameters.VulnerableResponseText = textvalue?.trim().length > 0 ? textvalue : null;
      } else {
        woRequestParameters.isVulnerable = false;
        woRequestParameters.VulnerableResponseText = null;
      }

      if (userChosenVandalismQuestion === "Yes") {
        woRequestParameters.crimeReferenceNumber =
          userChosenVandalismAdditionalInformation;
        woRequestParameters.repairCause = "Vandalism or Damage";
        woRequestParameters.repairCauseId =
          RepairCauseId[
          woRequestParameters.repairCause as keyof typeof RepairCauseId
          ];
      } else {
        woRequestParameters.crimeReferenceNumber = "";
        woRequestParameters.repairCause = "General Wear and Tear";
        woRequestParameters.repairCauseId =
          RepairCauseId[
          woRequestParameters.repairCause as keyof typeof RepairCauseId
          ];
      }

      await api.updateWorkOrderRepair(
        woRequestParameters,
        workOrderObject.id,
        "eTag"
      );
      dispatch(workOrderRepairObject(workOrderObject));
      return true;
    } catch (e) {
      console.error(e);
      dispatch(showFooter(true));
      props.history.push({
        pathname: '/repairJourneyErrorPage',
        state: { message: 'repair_Journey_Error_Message1' }
      });
      return false;
    } finally {
      setIsLoading(false);
      setButtonDisable(false);
    }
  };

  const callPageHandler = async () => {
    if (resumeDraftRepairVal) {
      const { vulnerabilityQuestion, vulnerableResponseText } = userResumeDraftDataCache;
      if (vulnerabilityQuestion !== radiovalue || vulnerableResponseText) {
        dispatch(resumeDraftRepair(false));
        dispatch(userChosenCovidQuestion(""));
        dispatch(userChosenContactDetails(""));
        dispatch(userChosenContactPhone(""));
        dispatch(userChosenContactName(""));
      }
    }

    if (textvalue != "" || radiovalue === "No" || (radiovalue == "Yes" && textvalue?.trim() != "")) {
      setError("none");
      const isSuccess = await submitForm();

      if(!isSuccess) return;

      props.history.push("/customerdetails");
    } else {
      setError("block");
    }
  };

  return (
    <>
      <HeaderJourney></HeaderJourney>
      <div className="container-fluid parent-footer repair-request p-0" id="velQues-container">
        <div
          className="padding-repair"
        >
          <h1 className="header-size" id="velQues-main-div">
            {t("Vulnerability")}
          </h1>
          <div id="repAddDet-div6"
            style={{ display: isError }} role="alert"
            placeholder="alert">
            <Message className="info-msg">
              {t("SSR056")}
            </Message>
          </div>
          {priorityCode === "V14" && V14AlertFlag === "true" && <div id="repAddDet-div6"
            role="alert"
            placeholder="alert">
            <Message className="info-msg">
              {t("V14_Alert_vul")}
            </Message>
          </div>
          }
          <div id="velQues-div1">
            <RadioGroup
              id="velQues-radiogroup"
              key={radiovalue}
              onChange={updateSelection}
              defaultValue={radiovalue}
              value={radiovalue}
            >
              <FormControlLabel
                id={"velQues-label1" + 1}
                value="Yes"
                control={
                  <Radio id="velQues-radio3" key="radioYes" />
                }
                label="Yes"
                placeholder="Yes"
              />
              {blockLoading ? (
                <Loader
                  type="ThreeDots"
                  color="#00BFFF"
                  height={70}
                  width={50}
                  timeout={5000}
                />
              ) : radiovalue === "Yes" && (
                <>
                  {(blockRepairJourney && blockErrorCode === "E36") &&
                    <Message id="velQues-span2" severity="error" className="warning-msg">
                      {t("BlockEMERepairMsg")}
                    </Message>
                  }
                  {(blockRepairJourney && blockErrorCode !== "E36") ?
                    <Message id="velQues-span2" severity="error" className="warning-msg">
                      {t("OrbisBlockMsg1")} <br />
                      {t("OrbisBlockMsg2")}  <strong className="font-bolder">{t("OrbisBlockNumber")}</strong>  {t("OrbisBlockMsg3")}
                    </Message> :
                    <>
                      {(!blockRepairJourney && (blockErrorCode !== "E36")) && <div id="velQues-span1" className="vulner-textarea mb-30">
                        <Message className="info-msg">
                          {t("SS039")}
                        </Message>

                        <textarea
                          aria-label="Vulnerability_Additional_Info"
                          id="velQues-textarea"
                          className="mt-30 text-area"
                          data-testid="textareaVulnerability"
                          placeholder={t("Vulnerability_Additional_Info")}
                          value={textvalue ?? ""}
                          onChange={(e) => onChange(e)}
                        />
                      </div>
                      }
                    </>
                  }

                </>
              )}
              <FormControlLabel
                id="velQues-label1"
                value="No"
                control={<Radio id="velQues-radio1" key="radioNo" />}
                label="No"
                placeholder="No"
              />
            </RadioGroup>
          </div>

        </div>
        <div className="col-md-12 marginTop-auto" id="velQues-div2">
          <div className="row m-0 footer-actionbtn">
            <div className="col btn-top padding-repair mb-0">
              <BackModal id="velQues-backmodal" back={backButtonHandler} />
              <ExitModalAndSave
                id="velQues-exitmodal"
                exit={exitButtonHandler}
                saveDraftAndExit={saveDraftAndExit}
                closeAfterSaving={closeAfterSaving}
              />
            </div>
            <div className="col text-end pt-24 padding-repair">
              <Button
                id="btn_vulnerability"
                disabled={buttondisable}
                onClick={callPageHandler}
                className="primary-btn"
              >
                {t("continuen_button")}{" "}
              </Button>
            </div>
          </div>
        </div>
        <span>
          {isLoading ? (
            <Loader
              type="ThreeDots"
              color="#00BFFF"
              height={70}
              width={50}
              timeout={5000}
            />
          ) : (
            <>
              <div></div>
            </>
          )}
        </span>
      </div>
    </>
  );
};
export default VulnerabilityQs;